import { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import { useLang } from "@/i18n";

const BAND_IMG =
  "https://images.unsplash.com/photo-1782948603191-065fb15e2e8e?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NDh8MHwxfHNlYXJjaHw0fHx3YXJlaG91c2UlMjBzaGVsdmVzJTIwY2FyZGJvYXJkJTIwYm94ZXMlMjBsb2dpc3RpY3N8ZW58MHx8fHwxNzkxMjU5NzA2fDA&ixlib=rb-4.1.0&q=85";

export default function ParallaxBand() {
  const { t } = useLang();
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start end", "end start"] });
  const y = useTransform(scrollYProgress, [0, 1], ["-14%", "14%"]);

  return (
    <section ref={ref} className="relative h-[52vh] overflow-hidden lg:h-[64vh]">
      <motion.img
        src={BAND_IMG}
        alt="ON-ALL warehouse aisle"
        loading="lazy"
        style={{ y }}
        className="absolute inset-0 h-[128%] w-full object-cover"
      />
      <div className="absolute inset-0 bg-obsidian/70" />
      <div className="relative flex h-full items-center justify-center px-5">
        <h2 className="font-display font-expanded text-center text-4xl font-black uppercase leading-tight tracking-tight text-paper sm:text-6xl lg:text-7xl">
          <span className="block">{t.band.line1}</span>
          <span className="text-stroke-light block">{t.band.line2}</span>
        </h2>
      </div>
    </section>
  );
}
